import ListFaq from './ListFaq'

export default ListFaq